import React, { Component, Fragment } from 'react';
import { Redirect, withRouter } from 'react-router-dom'
import Modal from './NewWorkInstruction/Modal'
import WIList from './WIList'
import WISummary from './WISummary'
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios'
import { WebSocketEventEmitter } from '../../Websockets/WebSocketEventEmitter'
import WIAssignments from './Assignments/Assignments'
import {leftArrowTip} from '../../Templates/icons'


class WorkInstructionsPage extends Component {
    signal = axios.CancelToken.source()
    state = {
        openModal: false,
        selectedWorkInstructionId: null,
        isLoading: true,
        assignedUsersIDs: [],
        confirmationMessage: "",
    }

    componentDidMount = () => {
        this.loadData()
        this.props.clearAuthor()
        WebSocketEventEmitter.on('BWI', (message) => {
            if (message.process === 'failed') {
                WebSocketEventEmitter.emit('WebsocketReceiver', { data: message });
            } else if (message.process === 'complete') {
                // Update the work instruction in Redux to mark it as assignable
                const wipId = message.sender; // or message.filename
                const currentWI = this.props.workInstructions[wipId];
                if (currentWI) {
                    const updatedWI = { ...currentWI, isAssignable: true };
                    // Use the existing updateWorkInstruction action to update Redux state
                    this.props.updateWorkInstruction(updatedWI);
                }
            }
        })
        let page = document.getElementById("work-instructions-page")
        page.addEventListener("keydown",this.stopTabScroll)
    }

    componentWillUnmount = () => {
        this.signal.cancel('Api is being canceled');
        clearTimeout(this.timeout)
        let page = document.getElementById("work-instructions-page")
        page.removeEventListener("keydown",this.stopTabScroll)
    }

    stopTabScroll=(e)=>{
        console.log("checking key pressed")
        if(e.keyCode == 9){
            e.preventDefault()
        }
    }

    // api requests are made with a AbortController cancel token. When the component unmounts the api request is aborted,
    loadData = () => {
        let signalToken = this.signal.token
        Promise.all([
            this.props.fetchAllWorkInstructions(signalToken),
            this.props.fetchAllTags(signalToken),
            this.props.fetchAllUsers(signalToken)
        ]).then(([res1, res2, res3]) => {
            this.setState({ isLoading: false })
        }).catch(err => {
            if (axios.isCancel(err)) {
                console.info('Work Instructions Page - ', err.message)
            } else {
                console.debug('Error', err.message)
            }
        });
    }

    closeConfirmation = (e) => {
        this.setState({ confirmationMessage: "" })
    }

    openConfirmation = (e) => {
        this.setState({ confirmationMessage: "Your assignment changes were successful.", assignmentsOpen: false }
        )
        setTimeout(this.closeConfirmation, 5001)
    }

    closeModal = () => this.setState({ openModal: false })

    cloneWorkInstruction = (e, workInstructionId) => {
        e.preventDefault()
        e.stopPropagation()
        this.props.cloneWorkInstruction(workInstructionId)
        this.setState({ selectedWorkInstructionId: null })
        //TODO need to auto select the recently cloned instruction
    }

    deleteWorkInstruction = (workInstructionId) => {
        this.props.deleteWorkInstruction(workInstructionId)
        this.setState({ selectedWorkInstructionId: null })
    }

    displayModal = () => {
        return this.state.openModal ? <Modal
            modalTitle={"New Work Instruction"}
            closeModal={this.closeModal}
            callingComponent={"Work Instructions Author Mainpage"}
            submitForm={this.submitForm}
        /> : null
    }

    openModal = () => this.setState(prevState => ({ openModal: !prevState.openModal}))

    //deselects WI if it is already selected, else selects WI.
    selectWorkInstruction = (workInstructionId) => {
        const isSelected = workInstructionId === this.state.selectedWorkInstructionId
        if (isSelected) {
            return this.setState({ 
                selectedWorkInstructionId: null, 
                assignedUsersIDs: null,
                assignmentsOpen:false
            })
        }

        this.assignUsersToWIP(workInstructionId)
    }

    assignUsersToWIP = (workInstructionId) => {
        let assignedUsersIDs = {}
        Object.values(this.props.users).forEach(user => {
            if (user.assignments) {
                assignedUsersIDs[user._id] = user.assignments.some(assignment => assignment.WIPID === workInstructionId)
            } else {
                assignedUsersIDs[user._id] = false
            }
        });

        this.setState({
            selectedWorkInstructionId: workInstructionId,
            assignedUsersIDs: assignedUsersIDs,
            assignmentsOpen:false
        })
    }



    submitForm = (url) => {
        this.setState(prevState => ({
            openModal: false,
            url: url
        }))
    }

    renderLoading = () => {
        this.timeout = setTimeout(() => this.setState({
            loadingInstruction: true
        }), 1000)
        return <div className="flex-centered max-size">
                <CircularProgress />
            </div>
    }

    render = () => {
        return <div id="work-instructions-page" className="work-instructions-page-window max-width rel" style={{ height: "calc(100% - 47px)" }}>
            {/* redirects if on loading animation */}
            {this.state.url && this.state.loadingInstruction ? <Redirect to={this.state.url} /> : null}
            {/* shows loading animation if a redirect url is present */}
            {this.state.url && !this.state.loadingInstruction ? this.renderLoading() 
            : <Fragment>
                <Fragment>
                    {this.displayModal()}
                </Fragment>
                <div id="work-instructions-page-content" className={`max-size flex ${this.state.openModal ? "modal-open" : ""}`}>
                <div id="success-banner" className="flex-centered fade-in-and-out max-width"
                    style={{ display: `${this.state.confirmationMessage ? "flex" : "none"}` }}
                    onClick={this.closeConfirmation}
                >
                    <p>{this.state.confirmationMessage}</p>
                </div>
                <WIList
                        selectedWorkInstructionId={this.state.selectedWorkInstructionId}
                        workInstructions={Object.values(this.props.workInstructions)}
                        tags={this.props.tags}
                        users={this.props.users}
                        loading={this.state.isLoading}
                        openModal={this.openModal}
                        closeModal={this.closeModal}
                        selectWorkInstruction={this.selectWorkInstruction}
                        showCreateButton={true}
                        showDetailsColumns={true}
                />

                {/* renders summary if a work instruction has been selected, else renders directions */}
                {this.state.selectedWorkInstructionId ? 
                    this.state.assignmentsOpen ? 
                        <WIAssignments 
                            selectedWIID={this.state.selectedWorkInstructionId}
                            users={this.props.users || []}
                            updateUserAssignment={this.assignUsersToWIP}
                            assignedUsersIDs={this.state.assignedUsersIDs}
                            assignUsers={this.props.assignUsers}
                            openConfirmation={this.openConfirmation}
                            cancel={() => this.setState({ assignmentsOpen: false })}
                            />
                    :
                        <WISummary
                            workInstruction={this.props.workInstructions[this.state.selectedWorkInstructionId]}
                            cloneWorkInstruction={this.cloneWorkInstruction}
                            previewWorkInstruction={this.props.previewWorkInstruction}
                            selectWorkInstruction={this.props.selectWorkInstruction}
                            deleteWorkInstruction={this.deleteWorkInstruction}
                            toggleAssignments={() => this.setState(prevState => ({assignmentsOpen: !prevState.assignmentsOpen}))}
                            fetchWorkInstructionForEdit={this.props.fetchWorkInstructionForEdit}
                            saveWorkInstruction={this.props.saveWorkInstruction}
                            setAuthorForEditing={this.props.setAuthorForEditing}
                        />
                :
                    <div id="wi-page-content-container" className="flex-column shadow">
                        <div id="directions-panel" className="flex-column-centered max-height">
                            {this.state.isLoading ? <h3 className="pageTitleFontSize">Your work instructions are being loaded</h3>
                                : <div className="flex-centered">
                                    {leftArrowTip}
                                   <h3 className="pageTitleFontSize">Select a work instruction to view more information.</h3>
                                  </div>}
                          </div>
                </div>}
                        </div>
            </Fragment>}
            </div>
    }
}

export default withRouter(WorkInstructionsPage)